<script lang="ts">
    import {page} from '$app/stores';
    import logoUrl from '$lib/assets/logo.svg';
    import HeaderSearch from './HeaderSearch.svelte';

    type MenuItem = {
        title: string;
        url: string;
        active: boolean;
    };

    export let authorized: boolean;

    let topMenu: MenuItem[];
    let mainMenu: MenuItem[];

    $: topMenu = [
        {title: 'О сервисе', url: '/what-can', active: $page.url.pathname.startsWith('/what-can')},
        {title: 'Блог', url: '/blog', active: $page.url.pathname.startsWith('/blog')},
        {title: 'Поставщикам', url: '/supplier', active: $page.url.pathname === '/supplier'},
        {title: 'Виджет на сайт', url: '/supplier/widget', active: $page.url.pathname.startsWith('/supplier/widget')},
        {title: 'Отзывы', url: '/reviews', active: $page.url.pathname.startsWith('/reviews')},
        {title: 'Вопрос-ответ', url: '/faq', active: $page.url.pathname.startsWith('/faq')},
        {title: 'Кнопка парсера', url: '/howto/button', active: $page.url.pathname === '/howto/button'},
    ];

    $: mainMenu = [
        {title: 'Каталог сайтов', url: '/catalog', active: $page.url.pathname.startsWith('/catalog')},
        {title: 'Тарифы', url: '/tariffs', active: $page.url.pathname.startsWith('/tariffs')},
        {title: 'База знаний', url: '/howto', active: $page.url.pathname.startsWith('/howto')},
    ];
</script>

<div class="py-1 bg-black-700">
    <nav class="container px-4">
        <ul class="flex gap-8 overflow-auto whitespace-nowrap overscroll-contain snap-x">
            {#each topMenu as item}
                <li>
                    <a class="text-sm text-white" class:font-medium={item.active} href={item.url}>{item.title}</a>
                </li>
            {/each}
        </ul>
    </nav>
</div>

<header class="bg-black-50">
    <nav class="container flex flex-col items-center p-4 gap-y-8 lg:flex-row lg:justify-between">
        <a class="order-1" href="/">
            <img alt="Q-Parser" src={logoUrl} class="h-14" />
        </a>

        <ul class="flex flex-wrap items-center justify-center order-4 sm:flex-nowrap lg:order-2 gap-x-8 gap-y-4">
            {#each mainMenu as item}
                <li>
                    <a class="text-black" href={item.url} class:font-medium={item.active}>{item.title}</a>
                </li>
            {/each}
        </ul>

        <div class="order-3 w-full max-w-sm lg:order-3 lg:w-48 xl:w-64">
            <HeaderSearch />
        </div>

        <a href="/my" class="order-2 lg:order-4 btn btn-green">
            <svg class="fill-white" height="16" width="12" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.149 6.46h-.305V5.001C10.844 2.302 8.755.048 6.143 0a13.633 13.633 0 0 0-.286 0C3.245.048 1.155 2.302 1.155 5.001V6.46H.851C.382 6.46 0 6.956 0 7.569v7.318C0 15.499.382 16 .851 16h10.298c.469 0 .851-.501.851-1.113V7.569c0-.613-.382-1.109-.851-1.109zm-4.184 4.76v2.211c0 .254-.207.468-.454.468H5.489c-.247 0-.454-.214-.454-.468V11.22c-.24-.242-.379-.576-.379-.946 0-.701.529-1.304 1.201-1.332.072-.003.214-.003.286 0 .672.028 1.201.631 1.201 1.332 0 .37-.139.704-.379.946zm1.874-4.76H3.161V5.001c0-1.607 1.274-2.936 2.839-2.936 1.564 0 2.839 1.329 2.839 2.936V6.46z"
                    fill-rule="evenodd"
                ></path>
            </svg>

            <span>{authorized ? 'Личный кабинет' : 'Вход / Регистрация'}</span>
        </a>
    </nav>
</header>
